const ErrorCode = {
    "ABDM-1000": "Unable to connect the database",
    "ABDM-1001": "No data found",
    "ABDM-1002": "Integrity violation",
    "ABDM-1003": "Email Gateway is unavailable",
    "ABDM-1004": "SMS Gateway is unavailable",
    "ABDM-1005": "Invalid receiver",
    "ABDM-1006": "Bad Request, invalid Request Body",
    "ABDM-1007": "The connection failed due to a timeout",
    "ABDM-1008": "SMS service is currently disabled",
    "ABDM-1009": "Email service is currently disabled",
    "ABDM-1010": "Validation failed",
    "ABDM-1011": "Gateway database unavailable",
    "ABDM-1012": "No records were found against the ABHA Address",
    "ABDM-1013": "Invalid ABHA Number",
    "ABDM-1014": "Invalid Mobile Email",
    "ABDM-1015": "Invalid Response",
    "ABDM-1016": "Invalid TimeStamp",
    "ABDM-1017": "Invalid TransactionId",
    "ABDM-1018": "Share Profile database unavailable",
    "ABDM-1019": "Dependent Service Unavailable",
    "ABDM-1020": "Unknown database",
    "ABDM-1021": "Lack of required privileges",
    "ABDM-1022": "Too many requests",
    "ABDM-1023": "Invalid User",
    "ABDM-1024": "Dependent service unavailable",
    "ABDM-1025": "Invalid ServiceId",
    "ABDM-1026": "Invalid Link Token",
    "ABDM-1027": "You are blocked. Please try again after 24 hours.",
    "ABDM-1028": "HIP is unavailable",
    "ABDM-1029": "The Redis server is unavailable",
    "ABDM-1030": "Invalid request ID",
  };
  
export default ErrorCode